import React from 'react';

const PaymentMethod = () => {
  return (
    <div>
      Payment Method
    </div>
  );
}

export default PaymentMethod;
